import { yupResolver } from "@hookform/resolvers/yup";
import { UploadImage } from "components";
import { MediaDirectoryKeys } from "constants/enums";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller, Resolver, useForm } from "react-hook-form";

import { inventoryManagerSchema } from "../../../helpers";
import { NameFields, PasswordFields, PhoneField } from "./atoms";
import {
  InventoryManagerFormProps,
  InventoryManagerFormValues
} from "./InventoryManagerForm.types";

import styles from "./InventoryManagerForm.module.scss";

const InventoryManagerForm = ({
  formId,
  defaultValues,
  onSubmit
}: InventoryManagerFormProps) => {
  const { control, handleSubmit } = useForm<InventoryManagerFormValues>({
    defaultValues,
    resolver: yupResolver(inventoryManagerSchema) as Resolver<any, any>
  });

  return (
    <form id={formId} className={styles.form} onSubmit={handleSubmit(onSubmit)}>
      <Controller
        control={control}
        name="image"
        render={({ field: { value, onChange }, fieldState: { error } }) => (
          <UploadImage
            className={styles.form_imageBlock}
            variant="primary"
            uploadLabel="Add photo"
            editLabel="Change photo"
            deleteLabel="Delete photo"
            value={value}
            onChange={onChange}
            errorMessage={error?.message}
            uploadDirectoryKey={MediaDirectoryKeys.InventoryManager}
            data-testid="inventory-manager--image"
          />
        )}
      />

      <NameFields control={control} />

      <PhoneField control={control} />

      <PasswordFields control={control} />
    </form>
  );
};

export default InventoryManagerForm;
